function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { Formatter, TableUtils } from '@deephaven/jsapi-utils';
import IrisGridProxyModel from "./IrisGridProxyModel.js";
/**
 * Factory to create an IrisGridDataModel based on a table or tree table, whatever is passed in.
 */
class IrisGridModelFactory {
  /**
   * @param table The Table or TreeTable object to create the model with
   * @param formatter The formatter to use
   * @returns An IrisGridModel that uses the table provided
   */
  static makeModel(dh, table) {
    var _arguments = arguments;
    return _asyncToGenerator(function* () {
      var formatter = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : new Formatter(dh);
      var inputTable = null;
      if (!TableUtils.isTreeTable(table) && !TableUtils.isPartitionedTable(table) && table.hasInputTable) {
        inputTable = yield table.inputTable();
      }
      return new IrisGridProxyModel(dh, table, formatter, inputTable);
    })();
  }
}
export default IrisGridModelFactory;
//# sourceMappingURL=IrisGridModelFactory.js.map